__turbopack_context__.v({
  "Actions": "BenchViewer-module__HweOeG__Actions",
  "Backdrop": "BenchViewer-module__HweOeG__Backdrop",
  "Button": "BenchViewer-module__HweOeG__Button",
  "Description": "BenchViewer-module__HweOeG__Description",
  "Frame": "BenchViewer-module__HweOeG__Frame",
  "FrameBlocker": "BenchViewer-module__HweOeG__FrameBlocker",
  "FrameContainer": "BenchViewer-module__HweOeG__FrameContainer",
  "Interactive": "BenchViewer-module__HweOeG__Interactive",
  "Popup": "BenchViewer-module__HweOeG__Popup",
  "Results": "BenchViewer-module__HweOeG__Results",
  "Root": "BenchViewer-module__HweOeG__Root",
  "Title": "BenchViewer-module__HweOeG__Title",
  "isDisabled": "BenchViewer-module__HweOeG__isDisabled",
});
